<div class="container">
    <div class="left-control-part">
        <div class="one-control cursor-none-select" *ngFor="let item of config.controls" [attr.tid]="item.tid"
            (click)="onAddControl($event,item,null)">
            <!-- <div class="control-icon">
                <smart-icon name="kanban" class="small light"></smart-icon>
            </div> -->
            <div class="control-name subtitle text-ellipsis" kendoTooltip tooltipClass="tooltip-adjust-right"
                [title]="item.name">
                {{item.name}}
            </div>
        </div>
    </div>
    <div class="middle-template-part">
        <section-shell [config]="config.template" [ableMoveUp]="false" [ableMoveDown]="false" [ableMoveLeft]="false"
            [ableMoveRight]="false" [selectedControl]="selectedControl" [invalidControlId]="config.invalidControlId"
            [options]="options" (selectChange)="onSelectChange($event)" (deleteControl)="onDeleteControl($event)"
            (controlOrderChanged)="afterControlOrderChanged($event)">
        </section-shell>
    </div>
    <div class="right-config-part">
        <ng-container #controlConfigContainer></ng-container>
        <div class="empty-config" *ngIf="!selectedControl">Please select a control to view detail configuration
        </div>
    </div>
</div>
